// @mui
import { TextField } from "@mui/material";
import PropTypes from "prop-types";
// form
import { Controller, useFormContext } from "react-hook-form";

// ----------------------------------------------------------------------

RHFTextField.propTypes = {
    name: PropTypes.string,
};
export default function RHFTextField({ name, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <TextField
                    {...field}
                    fullWidth
                    error={!!error}
                    helperText={error?.message}
                    inputProps={{
                        ...(field.value && { value: field.value }),
                    }}
                    {...other}
                />
            )}
        />
    );
}
